import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view content-panel">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi 👋, I am <span className="purple">Saurav</span> Jaiswal. 
            <br />
            <br />
            I've worked on with distributed systems that operate at scale - from petabyte storage infrastructure to AI-powered financial platforms processing billions in transactions.

            <br />
            <br />

            Over 5 years, I worked as a Software Development Engineer <a href="https://www.commbank.com.au/" className="purple" style={{ textDecoration: "none" }}>@Commonwealth Bank of Australia</a> and <a href="https://www.datacore.com" className="purple" style={{ textDecoration: "none" }}>@DataCore Software.</a> and <a href="https://www.worldquant.com" className="purple" style={{ textDecoration: "none" }}>@WorldQuant</a>.

            <br />
            <br />

            Currently pursuing MSc in Computer Science at the <a href="https://www.warwick.ac.uk/" className="purple" style={{ textDecoration: "none" }}>University of Warwick</a>, combining 5+ years of industry experience with advanced theoretical foundations in distributed systems and High Performance Computing and Artificial Intelligence.

            <br />
            <br />

            I'm passionate about solving problems that sit at the intersection of practical scalability and theoretical innovation - where real-world constraints meet cutting-edge research.

            <br />
            <br />

            <p style={{ color: "rgb(155 126 172)" }}>
              "Open to research engineering, principal engineering, and technical leadership opportunities in London."{" "}
            </p> 
          </p>
          
          {/* <footer className="blockquote-footer">saurav</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
